let menuSlideDuration = 500;

/**
 * UTILITIES
 */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

// automatically open offsite links in new window
var anchors = document.querySelectorAll("a");
for (var i = 0; i < anchors.length; i++) {
  if (anchors[i].hostname !== window.location.hostname) {
    anchors[i].setAttribute("target", "_blank");
  }
}

/* SLIDE UP */
let slideUp = (target, duration = menuSlideDuration) => {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    //alert("!");
  }, duration);
};

/* SLIDE DOWN */
let slideDown = (target, duration = menuSlideDuration) => {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};
/* TOOGLE */
var slideToggle = (target, duration = menuSlideDuration) => {
  if (window.getComputedStyle(target).display === "none") {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
};

/* DETECT IF MOBILE */
const isMobileDevice = /Mobi/i.test(window.navigator.userAgent);
if (isMobileDevice) {
  document.body.classList.add("mobile");
}

/**
 * ACCESSIBILITY
 */
//check if we're on desktop or mobile
const mobileBreakpoint = getComputedStyle(
  document.documentElement
).getPropertyValue("--mobileBreakpoint");
const isMobile = window.innerWidth <= parseInt(mobileBreakpoint);

if (!isMobile) {
  //trap focus for submenus
  document
    .querySelectorAll(".site-nav li.has-subnav > a")
    .forEach(function (el) {
      el.addEventListener("focus", function () {
        this.addEventListener("keydown", function (e) {
          // down arrow or enter pressed
          if (e.keyCode == 40 || e.keyCode == 13) {
            e.preventDefault();
            this.parentElement.classList.add("is-focused");
          }
        });
        document.addEventListener("keydown", function (e) {
          // escape pressed
          if (e.keyCode == 27) {
            document
              .querySelector("li.is-focused")
              .classList.remove("is-focused");
          }
        });
      });
    });
  document
    .querySelectorAll(".site-nav > li > a, .site-nav button")
    .forEach(function (el) {
      el.addEventListener("focus", function () {
        if (document.querySelector("li.is-focused")) {
          document
            .querySelector("li.is-focused")
            .classList.remove("is-focused");
        }
      });
      el.addEventListener("mouseenter", function () {
        if (document.querySelector("li.is-focused")) {
          document
            .querySelector("li.is-focused")
            .classList.remove("is-focused");
        }
      });
    });

  //trap focus for search
  document
    .querySelector(".search__input")
    .addEventListener("focus", function () {
      this.addEventListener("keydown", function (e) {
        // down arrow or enter pressed
        if (e.keyCode == 40) {
          document.querySelector("#predictive-search-results-list a").focus();
        }
      });
    });
}

/**
 * INITIALIZATION
 */
document.documentElement.className = document.documentElement.className.replace(
  "no-js",
  "js"
);

/**
 * NAVIGATION
 */
document
  .querySelector(".mobile-trigger:not(.animating)")
  .addEventListener("click", function () {
    this.classList.add("animating");
    setTimeout(() => {
      this.classList.remove("animating");
    }, menuSlideDuration);
    const nav = document.querySelector(".nav-bar");
    slideToggle(nav, menuSlideDuration);
  });

// sticky on scroll
const stickyHeader = document.getElementById("shopify-section-header");
const sticky = stickyHeader.offsetTop + stickyHeader.offsetHeight;
let lastScroll = 0;

window.addEventListener("scroll", () => {
  if (!isMobile) {
    const currentScroll = window.pageYOffset;
    if (window.pageYOffset >= sticky){
      if(currentScroll < lastScroll) {
        stickyHeader.classList.add("is-visible");
      } else {
        stickyHeader.classList.remove("is-visible");
      }
      stickyHeader.classList.add("is-sticky");
    } else {
      stickyHeader.classList.remove("is-sticky");
    }
    lastScroll = currentScroll;
  }
});

// reset on resize
window.addEventListener(
  "resize",
  debounce(function () {
    const menuBreakpoint = getComputedStyle(
      document.documentElement
    ).getPropertyValue("--mobileBreakpoint");
    if (window.innerWidth > menuBreakpoint) {
      if( document.querySelector(".nav-bar")){
      document.querySelector(".nav-bar").setAttribute("style", "");
      }
    }
  }),
  250
);

// open subnavs on mobile
if (isMobile) {
  document
    .querySelectorAll(".site-nav li.has-subnav > a")
    .forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        let openNav = document.querySelector(".has-subnav.is-focused");
        if (openNav && openNav !== this.parentElement) {
          document
            .querySelector(".has-subnav.is-focused")
            .classList.remove("is-focused");
        }
        this.parentElement.classList.toggle("is-focused");
        window.scrollTo({
          top: this.parentElement.offsetTop,
          left: 0,
          behavior: "smooth",
        });
      });
    });
}

/**
 * QUANTITY BUTTONS
 */

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

/**
 * Accessibility Focus Stuff
 */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

/**
 * Product Variant Stuff
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {

    if (!this.currentVariant || this.dataset.updateUrl === "false") return;


    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
    // Safe variant title update
if (this && this.currentVariant && this.currentVariant.id) {

  var get_id = this.currentVariant.id;

  var $variantEl = $(`.variant_titles_metaf[data-id='${get_id}']`);

  if ($variantEl.length) {

    var get_title = $variantEl.attr('data-title');

    if (get_title && get_title.trim() !== '') {
      $("h1.product__title.product_title_main").html(get_title);
    }

  }

}
var eu_error_hide = $(".hidden_eu_select select option[data-id='" + this.currentVariant.id + "']");
console.log(eu_error_hide);
if (eu_error_hide.length) {
  var get_eu_value = eu_error_hide.attr("avail-eu");

  if (get_eu_value === "true") {
    $(".eu-shipping-error-message").hide();
    $("#buylocal").show();
    $(".estimated_date_main").show();
    $(".product-form__buttons button").removeClass('eu_added_to_cart22');


  } else {
    $(".eu-shipping-error-message").show();
    $("#buylocal").hide();
    $(".estimated_date_main").hide();
        $(".product-form__buttons button").addClass('eu_added_to_cart22');



  }
}

  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const skuid = `sku-${this.dataset.section}`;
        const skuDestination = document.getElementById(skuid);
        const sku = html.getElementById(skuid);

        if (sku && skuDestination) skuDestination.innerHTML = sku.innerHTML;

        let selectedVariantImage = "";

        this.getVariantData().forEach((variant) => {
          if (variant.id === this.currentVariant.id && variant.featured_media) {
            selectedVariantImage = variant.featured_media.id;
          }
        });
        if(selectedVariantImage) {
          const selectedSlide = document.querySelector(
            "[data-variantid='" + selectedVariantImage + "']"
          );

          const selectedSlideIndex = Array.from(
            selectedSlide.parentElement.children
          ).indexOf(selectedSlide);

          window.swiperMain.slideTo(selectedSlideIndex);
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);





// smooth scroll js for dealer portal

document.addEventListener('DOMContentLoaded', function() {
  const btn = document.querySelector('.dealer-register-btn');
  if (btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector('.form-out-dealer');
      if (target) {
        const isIPad = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const scrollOffset = isIPad ? 150 : 190;
        window.scrollTo({
          top: target.offsetTop + scrollOffset,
          behavior: 'smooth'
        });
      }
    });
  }
});



